import { SectionSidebarItemStyled } from '@OnArk/styles/CondensableSidebar.styled';

import React from 'react';

import { MaxWidthStyled } from '@hangar31/rc-layout';
import NavLink from '@OnArk/NavLink';
import Icon from '@OnArk/SVGs/Icon';
interface SectionSidebar {
  id: string;
  name: string;
  type: SectionType;
  childSections: { id: string; name: string; type: SectionType }[];
}
function SectionItem({
  condensed,
  course,
  item,
  reorderOn,
}: {
  item: SectionSidebar;
  course: { id: string };
  condensed: boolean;
  reorderOn: boolean;
}) {
  return (
    <>
      <SectionSidebarItemStyled
        as={NavLink}
        css={{ pointerEvents: reorderOn ? 'none' : 'all' }}
        href={`/admin/classes/${course.id}/${item.id}/${item.type}`}
      >
        <Icon
          distance={-45}
          left="0.8"
          name={`SECTIONS_${item.type}`}
          position="right"
          right="0.8"
          size="30"
          tooltip={condensed ? item.name : ''}
        />
        <span>{item.name}</span>
      </SectionSidebarItemStyled>
      {item.childSections.length > 0 && (
        <MaxWidthStyled grid css={{ marginBottom: '1rem' }} rowGap={0}>
          {item.childSections.map(subSection => (
            <SectionSidebarItemStyled
              key={subSection.id}
              child
              as={NavLink}
              css={{
                paddingLeft: condensed ? '2rem' : '3rem',
                pointerEvents: reorderOn ? 'none' : 'all',
              }}
              href={`/admin/classes/${course.id}/${subSection.id}/${subSection.type}`}
            >
              <Icon
                distance={-45}
                name={`SECTIONS_${subSection.type}`}
                position="right"
                size="30"
                tooltip={condensed ? subSection.name : ''}
              />
              <span>{subSection.name}</span>
            </SectionSidebarItemStyled>
          ))}
        </MaxWidthStyled>
      )}
    </>
  );
}

export default SectionItem;
